<template>
    <div class="card-analyze">
        <div
            v-if="!data.isPaid"
            class="card-analyze__demo"
        >Демо</div>
        <div class="card-analyze__field card-analyze__field_date">
            <div class="card-analyze__text card-analyze__text_date">{{ data.date }}</div>
        </div>
        <div class="card-analyze__field">
            <div class="card-analyze__text card-analyze__text_label">Фамилия Имя Отчество</div>
            <div class="card-analyze__text">{{ data.lastName }} {{ data.firstName }} {{ data.middleName }}</div>
        </div>
        <div class="card-analyze__field">
            <div class="card-analyze__text card-analyze__text_label">Дата рождения</div>
            <div class="card-analyze__text">{{ data.birthdate }}</div>
        </div>
        <div v-if="false" class="card-analyze__field">
            <div class="card-analyze__text card-analyze__text_label">Алфавит (язык)</div>
            <div class="card-analyze__language">
                <div class="card-analyze__language-icon">
                    <img
                        :src="getAlphabetIcon(data.alphabet)"
                        class="card-analyze__language-icon-img"
                    >
                </div>
                <div class="card-analyze__text card-analyze__language-text">{{ getAlphabetText(data.alphabet) }}</div>
            </div>
        </div>
        <div class="card-analyze__field card-analyze__field_links">
            <div
                @click="getAnalyzeId(data.id)"
                class="card-analyze__link card-analyze__link_view"
            ><span>Просмотреть</span></div>
            <div
                @click="getPdf(data.id)"
                class="card-analyze__link card-analyze__link_download"
            ><span>Скачать PDF</span>
           </div>
           <div
                v-if="data.isPaid"
                @click="delAnalyze(data.id)"
                class="card-analyze__link card-analyze__link_delite"
           >Удалить</div>
        </div>
    </div>
</template>

<script>
    import alphabets from "../../_data/alphabets.json";

    export default {
        props: {
            data: Object,
        },
        data: () => ({
            alphabets,
        }),
        computed: {

        },
        methods: {
            async getAnalyzeId(id){
                await this.$store.dispatch('getAnalyzeId', id).then((response) => {
                    this.$store.commit('setAnalyze', response.data);
                    this.$router.push('/analyze');
                }).catch((error) => {
                    console.error(error);
                });
            },
            getAlphabetText(id){
                const result = alphabets.find((alphabet) => alphabet.id === id);
                return result.text;
            },
            getAlphabetIcon(id){
                let result = alphabets.find((alphabet) => alphabet.id === id);
                return result.icon;
            },
            async getPdf(id){
                await this.$store.dispatch('getPdf', id).then((response) => {
                    this.downloadFile(new Blob([response]), "myfile.pdf");
                }).catch((error) => {
                    console.error(error);
                });
            },
            downloadFile(blob, fileName){
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.append(link);
                link.click();
                link.remove();
                setTimeout(() => URL.revokeObjectURL(link.href), 7000);
            },
            async delAnalyze(id){
                const modal = document.createElement('div');
                modal.className = 'modal-overlay';
                
                modal.innerHTML = `
                    <div class="modal-content">
                        <h3 class="modal-title">Удалить анализ?</h3>
                        <p class="modal-text">Вы действительно хотите удалить этот анализ? Это действие нельзя отменить.</p>
                        <div class="modal-buttons">
                            <button class="modal-button modal-button--cancel" id="confirmNo">Отмена</button>
                            <button class="modal-button modal-button--confirm" id="confirmYes">Да, удалить</button>
                        </div>
                    </div>
                `;
                
                document.body.appendChild(modal);
                
                // Функция для плавного закрытия модалки
                const closeModal = () => {
                    return new Promise((resolve) => {
                        modal.classList.add('fade-out');
                        
                        setTimeout(() => {
                            if (modal.parentNode) {
                                document.body.removeChild(modal);
                            }
                            resolve();
                        }, 200);
                    });
                };
                
                return new Promise((resolve) => {
                    const confirmBtn = modal.querySelector('#confirmYes');
                    const cancelBtn = modal.querySelector('#confirmNo');

                    confirmBtn.onclick = async () => {
                        confirmBtn.disabled = true;
                        cancelBtn.disabled = true;

                        await closeModal();

                        const cardElement = this.$el;
                        cardElement.style.transform = 'scale(0.8)';
                        cardElement.style.opacity = '0';
                        cardElement.style.transition = 'all 0.3s ease';

                        const animation = new Promise((animationResolve) => setTimeout(animationResolve, 300));

                        try {
                            await Promise.all([
                                this.$store.dispatch('deleteProfileAnalyze', id),
                                animation,
                            ]);

                            this.$store.commit('removeProfileAnalyze', id);

                            this.$toast.success('Анализ успешно удалён', {
                                position: 'top-right',
                                duration: 3000,
                            });

                            resolve(true);
                        } catch (error) {
                            cardElement.style.transform = '';
                            cardElement.style.opacity = '';
                            cardElement.style.transition = '';

                            const errorMessage = (error && error.data && error.data.message)
                                ? error.data.message
                                : 'Не удалось удалить анализ';
                            this.$toast.error(errorMessage, {
                                position: 'top-right',
                                duration: 3000,
                            });

                            resolve(false);
                        }
                    };
                    
                    cancelBtn.onclick = async () => {
                        await closeModal();
                        resolve(false);
                    };
                    
                    // Закрытие по клику на оверлей
                    modal.onclick = async (e) => {
                        if (e.target === modal) {
                            await closeModal();
                            resolve(false);
                        }
                    };
                });
            }
            
        },
    }
</script>

<style src="./card-analyze.less" lang="less"></style>
